import { render, staticRenderFns } from "./ListCategory.vue?vue&type=template&id=0a6e685e&scoped=true&"
import script from "./ListCategory.vue?vue&type=script&lang=js&"
export * from "./ListCategory.vue?vue&type=script&lang=js&"
import style0 from "./ListCategory.vue?vue&type=style&index=0&id=0a6e685e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6e685e",
  null
  
)

export default component.exports